import React, {useEffect} from 'react';
import ModulePageFrame from '../../custom-modules/components/module-page-frame';
import {makeStyles} from '@material-ui/core';
import {useUser} from '../../auth/utils';
import analytics from '../../../analytics';

const useStyles = makeStyles(() => ({
  iframe: {
    height: '99vh',
  },
}));

type AnitaOnboardingMessage = {
  type: 'ONBOARDING_COMPLETE',
  data: {
    storeDomain: string,
    token: string,
  },
};

export default function AnitaOnboarding() {
  const classes = useStyles();

  const user = useUser();

  useEffect(() => {
    if (user) {
      analytics.fireCustomEvent('Onboarding Started', {
        category: 'Onboarding',
        action: 'Started',
        user_type: user.type,
      });
    }
  }, [user]);

  useEffect(() => {
    const handleMessageEvent = (event: MessageEvent) => {
      const eventData: AnitaOnboardingMessage = event.data;

      if (eventData.type !== 'ONBOARDING_COMPLETE') {
        return;
      }

      console.log({
        eventData,
      });

      const {storeDomain, token} = eventData.data;

      const params = new URLSearchParams(window.location.search);
      params.append('anita_onboarding', '1');

      params.append('s_u_token', token);
      analytics.fireCustomEvent('Onboarding Completed', undefined, [
        'user-guiding',
      ]);

      const queryString = params.toString();
      const querySuffix = queryString ? `?${queryString}` : '';

      window.location.replace(
        `https://${storeDomain}/admin/home${querySuffix}`
      );
    };

    window.addEventListener('message', handleMessageEvent);

    return () => {
      window.removeEventListener('message', handleMessageEvent);
    };
  }, []);

  return <ModulePageFrame page="anita-onboarding" className={classes.iframe} />;
}
